import { render, staticRenderFns } from "./MiddleForSharingView.vue?vue&type=template&id=73e766ae&scoped=true"
import script from "./MiddleForSharingView.vue?vue&type=script&lang=js"
export * from "./MiddleForSharingView.vue?vue&type=script&lang=js"
import style0 from "./MiddleForSharingView.vue?vue&type=style&index=0&id=73e766ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e766ae",
  null
  
)

export default component.exports